// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../dist/node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../dist/node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.styles_container__MXuYV {
  box-sizing: border-box;
  width: 100%;
  height: 100%;
  display: flex;
  flex-direction: column;
  justify-content: flex-start;
  align-items: flex-start;
  margin: 13px 18px;
  max-width: 800px;
  margin: 0 auto;
}

.styles_information__v-CfO {
  width: 100%;
  height: auto;
}

.styles_switchDescription__fSenK {
  font-style: normal;
  font-weight: 400;
  font-size: 12px;
  line-height: 18px;
  text-align: right;
  color: #484848;
}

.styles_sidebar__ptUSl {
  width: 100%;
  border-right: 1px solid #e9e9e9;
  padding-right: 1%;
  height: 100%;
}

.styles_audioBox__tAoR2 {
  display: flex;
  justify-content: center;
  align-items: center;
  width: 100%;
  height: auto;
  overflow-x: auto;
  margin-top: auto;
  margin-bottom: 10px;
  margin-left: 10px;
  margin-right: 10px;
}

.styles_audioBox__tAoR2 audio {
  height: 50px;
}

.styles_activeMenu__3OuRR {
  color: #D8000D;
  border-bottom: 2px solid #D8000D;
  width: 25%;
  display: flex;
  justify-content: center;
  align-items: center;
  padding: 5px;
  padding-top: 0px;
  cursor: pointer;
}

.styles_unActiveMenu__ukahj {
  color: #575757;
  border-bottom: none;
  width: 25%;
  display: flex;
  justify-content: center;
  align-items: center;
  padding: 5px;
  padding-top: 0px;
  cursor: pointer;
}

.styles_experimental__CMxAP {
  font-size: 10px;
  margin: 0 8px;
}

.styles_imageAbsoluteCover__Z0zvq {
  box-sizing: border-box;
  position: absolute;
  top: 0;
  left: 0;
  background-color: rgba(0, 0, 0, 0.5);
  display: flex;
  flex-direction: row;
  justify-content: center;
  align-items: center;
  width: 100%;
  height: 100%;
}

.styles_videoContainer__4IR0R {
  width: 100%;
  margin: 0 auto;
  box-sizing: border-box;
  height: auto;
  background-repeat: no-repeat;
  background-size: cover;
  display: flex;
  flex-direction: row;
  align-items: center;
  justify-content: center;
  position: relative;
  height: 200px;
}

.styles_musicBg__tM7JM {
  background-color: #000;
}

.styles_videoStyle__eL7\\+s {
  height: 100% !important;
  width: 100%;
  background-color: #000;
}

.styles_absoluteBoxLoadingContainer__\\+\\+yEi {
  left: 0;
  top: 0;
  position: absolute;
  width: 100%;
  height: 100%;
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
}

.styles_absoluteBoxLoading__7t6Ks {
  width: calc(100% - 36px);
  height: auto;
  aspect-ratio: 1.8;
  background: #f4f4f4;
  border-radius: 8px;
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: flex-end;
}

.styles_text__dThwI {
  font-style: normal;
  font-weight: 500;
  font-size: 12px;
  line-height: 18px;
  color: #000000;
}

.styles_number__lf7Em {
  margin: 6px 0px;
  font-style: normal;
  font-weight: 400;
  font-size: 12px;
  line-height: 18px;
  /* identical to box height, or 150% */
  color: #000000;
}

.styles_inputBox__V620u {
  width: 80%;
  height: 7px;
  border-radius: 8px;
  margin: 0 8px;
  background: #d9d9d9;
  border-radius: 8px;
  margin-bottom: 20px;
}

.styles_progress__c6hkw {
  height: 7px;
  background: #ff6871;
  border-radius: 8px;
  transition: all 1s;
}

.styles_uploadDone__XC64X {
  box-sizing: border-box;
  display: flex;
  width: 100%;
  height: auto;
  justify-content: space-between;
  align-items: center;
  margin: 4px 0;
}

.styles_uploadDoneText__WnMLQ {
  font-style: normal;
  font-weight: 400;
  font-size: 10px;
  line-height: 18px;
  color: #d8000d;
}

.styles_uploadDoneSize__NC2VW {
  font-style: normal;
  font-weight: 400;
  font-size: 10px;
  line-height: 18px;
  /* identical to box height, or 180% */
  color: #000000;
}

.styles_coverTitle__9ZBSQ {
  font-style: normal;
  font-weight: 500;
  font-size: 12px;
  line-height: 18px;
  /* identical to box height, or 150% */
  color: #000000;
  margin: 6px 0;
}

.styles_coverDescription__b7ZyE {
  font-style: normal;
  font-weight: 400;
  font-size: 12px;
  line-height: 18px;
  /* or 150% */
  text-align: right;
  color: #484848;
}

.styles_thumbnailContainer__9NqVY {
  box-sizing: border-box;
  width: 100%;
  height: auto;
  display: flex;
  justify-content: flex-start;
  align-items: flex-start;
  flex-wrap: wrap;
  margin: 8px 0;
}

.styles_thumbnailContainer__9NqVY > div {
  box-sizing: border-box;
  width: 48%;
  height: auto;
  aspect-ratio: 1.7;
  margin: 1%;
  background: #f1f1f1;
  position: relative;
  display: flex;
  justify-content: center;
  align-items: center;
}

.styles_thumbnailContainer__9NqVY > div > span {
  font-style: normal;
  font-weight: 500;
  font-size: 12px;
  line-height: 18px;
  /* identical to box height, or 150% */
  text-align: right;
  color: #6b6b6b;
}

.styles_buttonContainer__U5Tck {
  box-sizing: border-box;
  display: flex;
  justify-content: space-between;
  align-items: stretch;
  width: 100%;
  height: auto;
  padding-bottom: 11px;
  border-bottom: 1px solid #e9e9e9;
}

.styles_buttonContainer__U5Tck .styles_button__USepc {
  font-style: normal;
  font-weight: 400;
  font-size: 14px;
  line-height: 22px;
  display: flex;
  align-items: center;
  text-align: center;
  color: #d8000d;
  border: 1px solid #d8000d;
  background: inherit;
  border-radius: 4px;
  width: 49%;
  height: auto;
  aspect-ratio: 8;
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
  max-height: 38px;
}

.styles_videoLink__2zO1V {
  box-sizing: border-box;
  width: 100%;
  height: auto;
  display: flex;
  flex-direction: column;
  justify-content: flex-start;
  align-items: flex-start;
}

.styles_videoLink__2zO1V .styles_linkHeader__rWaXy {
  box-sizing: border-box;
  width: 100%;
  height: auto;
  display: flex;
  flex-direction: row;
  justify-content: space-between;
  align-items: center;
  margin: 5px 0;
}

.styles_videoLink__2zO1V .styles_linkHeader__rWaXy > p {
  font-style: normal;
  font-weight: 500;
  font-size: 14px;
  line-height: 22px;
  color: #3c3c3c;
}

.styles_videoLink__2zO1V .styles_linkHeader__rWaXy > div {
  width: auto;
  display: flex;
  justify-content: flex-end;
}

.styles_videoLink__2zO1V .styles_link__5ydTE {
  box-sizing: border-box;
  width: 100%;
  height: auto;
  display: flex;
  flex-direction: row;
  justify-content: flex-end;
  align-items: center;
  word-break: break-all;
  text-align: left;
  font-style: normal;
  font-weight: 400;
  font-size: 12px;
  line-height: 19px;
  color: #ff3c45;
  margin: 5px 0;
}

.styles_submitButtonsContainer__AUX5P {
  box-sizing: border-box;
  display: flex;
  justify-content: space-between;
  align-items: center;
  width: 100%;
  height: auto;
  padding-bottom: 11px;
  margin-top: 25px;
}

.styles_submitButtonsContainer__AUX5P .styles_button__USepc {
  font-style: normal;
  font-weight: 400;
  font-size: 14px;
  line-height: 22px;
  display: flex;
  align-items: center;
  text-align: center;
  color: #d8000d;
  border: 1px solid #d8000d;
  background: inherit;
  border-radius: 4px;
  width: 49%;
  height: auto;
  aspect-ratio: 14;
  max-height: 38px;
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
  margin: 0 auto;
}

.styles_submitButtonsContainer__AUX5P .styles_button__USepc:nth-child(1) {
  background: #d8000d;
  border: 1px solid #d8000d;
  color: #ffffff;
}

.styles_redBorder__YGqHJ {
  border: 1px solid #d8000d;
}

.styles_grayBorder__Obrv5 {
  border: 1px solid #f1f1f1;
  min-height: 100px;
}

.styles_error__xX3Ai {
  font-style: normal;
  font-weight: 500;
  font-size: 14px;
  line-height: 20px;
  color: #ff9315;
  margin-top: 8px;
  margin-right: 20px;
}

.styles_lds_ring__lDIHb {
  display: inline-block;
  position: relative;
  width: 20px;
  height: 20px;
  margin-bottom: 10px;
}

.styles_lds_ring__lDIHb div {
  box-sizing: border-box;
  display: block;
  position: absolute;
  width: 14px;
  height: 14px;
  margin: 8px;
  border: 1px solid #d8000d;
  border-radius: 50%;
  animation: styles_lds_ring__lDIHb 1.2s cubic-bezier(0.5, 0, 0.5, 1) infinite;
  border-color: #d8000d transparent transparent transparent;
}

.styles_lds_ring__lDIHb div:nth-child(1) {
  animation-delay: -0.45s;
}

.styles_lds_ring__lDIHb div:nth-child(2) {
  animation-delay: -0.3s;
}

.styles_lds_ring__lDIHb div:nth-child(3) {
  animation-delay: -0.15s;
}

@keyframes styles_lds_ring__lDIHb {
  0% {
    transform: rotate(0deg);
  }
  100% {
    transform: rotate(360deg);
  }
}
@media only screen and (max-width: 1300px) {
  .styles_responsiveText__pJ24t {
    flex-direction: column;
  }
}
.styles_lds_ringSave__ZnH0g {
  height: 40px;
}

.styles_lds_ringSave__ZnH0g div {
  box-sizing: border-box;
  display: block;
  position: absolute;
  width: 14px;
  height: 14px;
  border: 1px solid #d8000d;
  border-radius: 50%;
  animation: styles_lds_ring__lDIHb 1.2s cubic-bezier(0.5, 0, 0.5, 1) infinite;
  border-color: #d8000d transparent transparent transparent;
}

.styles_lds_ringSave__ZnH0g div:nth-child(1) {
  animation-delay: -0.45s;
}

.styles_lds_ringSave__ZnH0g div:nth-child(2) {
  animation-delay: -0.3s;
}

.styles_lds_ringSave__ZnH0g div:nth-child(3) {
  animation-delay: -0.15s;
}

@keyframes styles_lds_ringSave__ZnH0g {
  0% {
    transform: rotate(0deg);
  }
  100% {
    transform: rotate(360deg);
  }
}
.styles_lds_ringSubmit__oShXu {
  height: 30px !important;
  width: 30px !important;
}

.styles_noBackground__if6nc {
  background-color: transparent !important;
}

.styles_lds_ringSubmit__oShXu div {
  box-sizing: border-box;
  display: block;
  position: absolute;
  width: 14px;
  height: 14px;
  border: 1px solid #ffffff;
  border-radius: 50%;
  animation: styles_lds_ring__lDIHb 1.2s cubic-bezier(0.5, 0, 0.5, 1) infinite;
  border-color: #ffffff transparent transparent transparent;
}

.styles_lds_ringSubmit__oShXu div:nth-child(1) {
  animation-delay: -0.45s;
}

.styles_lds_ringSubmit__oShXu div:nth-child(2) {
  animation-delay: -0.3s;
}

.styles_lds_ringSubmit__oShXu div:nth-child(3) {
  animation-delay: -0.15s;
}

@keyframes styles_lds_ringSubmit__oShXu {
  0% {
    transform: rotate(0deg);
  }
  100% {
    transform: rotate(360deg);
  }
}
@media only screen and (max-width: 1000px) {
  .styles_container__MXuYV {
    width: 90%;
    flex-direction: column;
    justify-content: flex-start;
    align-items: center;
    margin: 0 auto;
  }
  .styles_flexStyle__XV5tp {
    flex-direction: column;
    justify-content: flex-start;
    align-items: center;
  }
  .styles_activeMenu__3OuRR,
  .styles_unActiveMenu__ukahj {
    width: 40%;
  }
}
@media only screen and (max-width: 300px) {
  .styles_container__MXuYV {
    width: 70%;
  }
}`, "",{"version":3,"sources":["webpack://./../src/renderer/components/UploadingVideoModal/styles.module.scss"],"names":[],"mappings":"AAAA;EACE,sBAAA;EACA,WAAA;EACA,YAAA;EACA,aAAA;EACA,sBAAA;EACA,2BAAA;EACA,uBAAA;EACA,iBAAA;EACA,gBAAA;EACA,cAAA;AACF;;AAEA;EACE,WAAA;EACA,YAAA;AACF;;AAEA;EACE,kBAAA;EACA,gBAAA;EACA,eAAA;EACA,iBAAA;EAEA,iBAAA;EAEA,cAAA;AADF;;AAIA;EACE,WAAA;EACA,+BAAA;EACA,iBAAA;EACA,YAAA;AADF;;AAWA;EACE,aAAA;EACA,uBAAA;EACA,mBAAA;EACA,WAAA;EACA,YAAA;EAEA,gBAAA;EACA,gBAAA;EACA,mBAAA;EACA,iBAAA;EACA,kBAAA;AATF;;AAYA;EACE,YAAA;AATF;;AAqCA;EACE,cAAA;EACA,gCAAA;EACA,UAAA;EACA,aAAA;EACA,uBAAA;EACA,mBAAA;EACA,YAAA;EACA,gBAAA;EACA,eAAA;AAlCF;;AAqCA;EACE,cAAA;EACA,mBAAA;EACA,UAAA;EACA,aAAA;EACA,uBAAA;EACA,mBAAA;EACA,YAAA;EACA,gBAAA;EACA,eAAA;AAlCF;;AAsCA;EACE,eAAA;EACA,aAAA;AAnCF;;AAsCA;EACE,sBAAA;EACA,kBAAA;EACA,MAAA;EACA,OAAA;EACA,oCAAA;EACA,aAAA;EACA,mBAAA;EACA,uBAAA;EACA,mBAAA;EACA,WAAA;EACA,YAAA;AAnCF;;AAsCA;EACE,WAAA;EACA,cAAA;EACA,sBAAA;EACA,YAAA;EAGA,4BAAA;EACA,sBAAA;EACA,aAAA;EACA,mBAAA;EACA,mBAAA;EACA,uBAAA;EACA,kBAAA;EACA,aAAA;AArCF;;AAwCA;EACE,sBAAA;AArCF;;AA4CA;EACE,uBAAA;EACA,WAAA;EACA,sBAAA;AAzCF;;AA4CA;EACE,OAAA;EACA,MAAA;EACA,kBAAA;EACA,WAAA;EACA,YAAA;EACA,aAAA;EACA,sBAAA;EACA,mBAAA;EACA,uBAAA;AAzCF;;AA4CA;EACE,wBAAA;EACA,YAAA;EACA,iBAAA;EACA,mBAAA;EACA,kBAAA;EACA,aAAA;EACA,sBAAA;EACA,mBAAA;EACA,yBAAA;AAzCF;;AA4CA;EACE,kBAAA;EACA,gBAAA;EACA,eAAA;EACA,iBAAA;EACA,cAAA;AAzCF;;AA4CA;EACE,eAAA;EACA,kBAAA;EACA,gBAAA;EACA,eAAA;EACA,iBAAA;EACA,qCAAA;EACA,cAAA;AAzCF;;AA4CA;EACE,UAAA;EACA,WAAA;EACA,kBAAA;EACA,aAAA;EACA,mBAAA;EACA,kBAAA;EACA,mBAAA;AAzCF;;AA4CA;EACE,WAAA;EACA,mBAAA;EACA,kBAAA;EACA,kBAAA;AAzCF;;AA4CA;EACE,sBAAA;EACA,aAAA;EACA,WAAA;EACA,YAAA;EACA,8BAAA;EACA,mBAAA;EACA,aAAA;AAzCF;;AA4CA;EACE,kBAAA;EACA,gBAAA;EACA,eAAA;EACA,iBAAA;EAEA,cAAA;AA1CF;;AA6CA;EACE,kBAAA;EACA,gBAAA;EACA,eAAA;EACA,iBAAA;EACA,qCAAA;EACA,cAAA;AA1CF;;AA6CA;EACE,kBAAA;EACA,gBAAA;EACA,eAAA;EACA,iBAAA;EACA,qCAAA;EAEA,cAAA;EACA,aAAA;AA3CF;;AA8CA;EACE,kBAAA;EACA,gBAAA;EACA,eAAA;EACA,iBAAA;EACA,YAAA;EAEA,iBAAA;EAEA,cAAA;AA7CF;;AAgDA;EACE,sBAAA;EACA,WAAA;EACA,YAAA;EACA,aAAA;EACA,2BAAA;EACA,uBAAA;EACA,eAAA;EACA,aAAA;AA7CF;;AAgDA;EACE,sBAAA;EACA,UAAA;EACA,YAAA;EACA,iBAAA;EACA,UAAA;EACA,mBAAA;EAEA,kBAAA;EACA,aAAA;EACA,uBAAA;EACA,mBAAA;AA9CF;;AAiDA;EACE,kBAAA;EACA,gBAAA;EACA,eAAA;EACA,iBAAA;EACA,qCAAA;EAEA,iBAAA;EAEA,cAAA;AAhDF;;AAmDA;EACE,sBAAA;EACA,aAAA;EACA,8BAAA;EACA,oBAAA;EAEA,WAAA;EACA,YAAA;EACA,oBAAA;EACA,gCAAA;AAjDF;;AAoDA;EACE,kBAAA;EACA,gBAAA;EACA,eAAA;EACA,iBAAA;EACA,aAAA;EACA,mBAAA;EACA,kBAAA;EACA,cAAA;EACA,yBAAA;EACA,mBAAA;EACA,kBAAA;EACA,UAAA;EACA,YAAA;EAEA,eAAA;EACA,aAAA;EACA,sBAAA;EACA,uBAAA;EACA,mBAAA;EACA,gBAAA;AAlDF;;AAsDA;EACE,sBAAA;EACA,WAAA;EACA,YAAA;EACA,aAAA;EACA,sBAAA;EACA,2BAAA;EACA,uBAAA;AAnDF;;AAsDA;EACE,sBAAA;EACA,WAAA;EACA,YAAA;EACA,aAAA;EACA,mBAAA;EACA,8BAAA;EACA,mBAAA;EACA,aAAA;AAnDF;;AAsDA;EACE,kBAAA;EACA,gBAAA;EACA,eAAA;EACA,iBAAA;EACA,cAAA;AAnDF;;AAsDA;EACE,WAAA;EACA,aAAA;EACA,yBAAA;AAnDF;;AAsDA;EACE,sBAAA;EACA,WAAA;EACA,YAAA;EACA,aAAA;EACA,mBAAA;EACA,yBAAA;EACA,mBAAA;EACA,qBAAA;EACA,gBAAA;EACA,kBAAA;EACA,gBAAA;EACA,eAAA;EACA,iBAAA;EACA,cAAA;EACA,aAAA;AAnDF;;AAsDA;EACE,sBAAA;EACA,aAAA;EACA,8BAAA;EACA,mBAAA;EACA,WAAA;EACA,YAAA;EACA,oBAAA;EACA,gBAAA;AAnDF;;AAsDA;EACE,kBAAA;EACA,gBAAA;EACA,eAAA;EACA,iBAAA;EACA,aAAA;EACA,mBAAA;EACA,kBAAA;EACA,cAAA;EACA,yBAAA;EACA,mBAAA;EACA,kBAAA;EACA,UAAA;EACA,YAAA;EAEA,gBAAA;EACA,gBAAA;EACA,aAAA;EACA,sBAAA;EACA,uBAAA;EACA,mBAAA;EACA,cAAA;AApDF;;AAuDA;EAGE,mBAAA;EACA,yBAAA;EACA,cAAA;AAtDF;;AAyDA;EACE,yBAAA;AAtDF;;AAyDA;EACE,yBAAA;EACA,iBAAA;AAtDF;;AA0DA;EACE,kBAAA;EACA,gBAAA;EACA,eAAA;EACA,iBAAA;EACA,cAAA;EACA,eAAA;EACA,kBAAA;AAvDF;;AA0DA;EACE,qBAAA;EACA,kBAAA;EACA,WAAA;EACA,YAAA;EACA,mBAAA;AAvDF;;AA2DA;EACE,sBAAA;EACA,cAAA;EACA,kBAAA;EACA,WAAA;EACA,YAAA;EACA,WAAA;EACA,yBAAA;EACA,kBAAA;EACA,4EAAA;EACA,yDAAA;AAxDF;;AA2DA;EACE,uBAAA;AAxDF;;AA2DA;EACE,sBAAA;AAxDF;;AA2DA;EACE,uBAAA;AAxDF;;AA2DA;EACE;IACE,uBAAA;EAxDF;EA2DA;IACE,yBAAA;EAzDF;AACF;AA4DA;EACE;IACE,sBAAA;EA1DF;AACF;AA+DA;EAIE,YAAA;AAhEF;;AAuEA;EACE,sBAAA;EACA,cAAA;EACA,kBAAA;EACA,WAAA;EACA,YAAA;EAEA,yBAAA;EACA,kBAAA;EACA,4EAAA;EACA,yDAAA;AArEF;;AAwEA;EACE,uBAAA;AArEF;;AAwEA;EACE,sBAAA;AArEF;;AAwEA;EACE,uBAAA;AArEF;;AAwEA;EACE;IACE,uBAAA;EArEF;EAwEA;IACE,yBAAA;EAtEF;AACF;AA2EA;EAIE,uBAAA;EACA,sBAAA;AA5EF;;AAmFA;EACE,wCAAA;AAhFF;;AAmFA;EACE,sBAAA;EACA,cAAA;EACA,kBAAA;EACA,WAAA;EACA,YAAA;EAEA,yBAAA;EACA,kBAAA;EACA,4EAAA;EACA,yDAAA;AAjFF;;AAoFA;EACE,uBAAA;AAjFF;;AAoFA;EACE,sBAAA;AAjFF;;AAoFA;EACE,uBAAA;AAjFF;;AAoFA;EACE;IACE,uBAAA;EAjFF;EAoFA;IACE,yBAAA;EAlFF;AACF;AAsFA;EAEE;IACE,UAAA;IAEA,sBAAA;IACA,2BAAA;IACA,mBAAA;IACA,cAAA;EAtFF;EAyFA;IACE,sBAAA;IACA,2BAAA;IACA,mBAAA;EAvFF;EA0FA;;IAEE,UAAA;EAxFF;AACF;AA2FA;EAEE;IACE,UAAA;EA1FF;AACF","sourcesContent":[".container {\n  box-sizing: border-box;\n  width: 100%;\n  height: 100%;\n  display: flex;\n  flex-direction: column;\n  justify-content: flex-start;\n  align-items: flex-start;\n  margin: 13px 18px;\n  max-width: 800px;\n  margin: 0 auto;\n}\n\n.information {\n  width: 100%;\n  height: auto;\n}\n\n.switchDescription {\n  font-style: normal;\n  font-weight: 400;\n  font-size: 12px;\n  line-height: 18px;\n\n  text-align: right;\n\n  color: #484848;\n}\n\n.sidebar {\n  width: 100%;\n  border-right: 1px solid #e9e9e9;\n  padding-right: 1%;\n  height: 100%;\n  // display: flex;\n  // justify-content: flex-start;\n  // align-items: center;\n}\n\n.sidebar>div {\n  // width: 50%;\n}\n\n.audioBox {\n  display: flex;\n  justify-content: center;\n  align-items: center;\n  width: 100%;\n  height: auto;\n  // width:100% !important;\n  overflow-x: auto;\n  margin-top: auto;\n  margin-bottom: 10px;\n  margin-left: 10px;\n  margin-right: 10px;\n}\n\n.audioBox audio {\n  height: 50px;\n}\n\n// .sidebar audio::-webkit-media-controls-mute-button {\n//   display: none !important;\n// }\n\n// .sidebar audio::-webkit-media-controls-mute-button:hover {\n//   display: none !important;\n// }\n\n\n// .sidebar  audio::-webkit-media-controls-volume-slider {\n//   display: none !important;\n// }\n// .sidebar  audio::-webkit-media-controls-volume-slider:hover {\n//   display: none !important;\n// }\n// .sidebar  audio::-webkit-media-controls-volume-slider:hover {\n//   display: none !important;\n// }\n// .sidebar audio::-webkit-media-controls-enclosure {\n//   overflow:hidden;\n// }\n\n// .sidebar audio::-webkit-media-controls-panel {\n//   width: calc(100% + 30px); /* Adjust as needed */\n// }\n.activeMenu {\n  color: #D8000D;\n  border-bottom: 2px solid #D8000D;\n  width: 25%;\n  display: flex;\n  justify-content: center;\n  align-items: center;\n  padding: 5px;\n  padding-top: 0px;\n  cursor: pointer;\n}\n\n.unActiveMenu {\n  color: #575757;\n  border-bottom: none;\n  width: 25%;\n  display: flex;\n  justify-content: center;\n  align-items: center;\n  padding: 5px;\n  padding-top: 0px;\n  cursor: pointer;\n\n}\n\n.experimental {\n  font-size: 10px;\n  margin: 0 8px;\n}\n\n.imageAbsoluteCover {\n  box-sizing: border-box;\n  position: absolute;\n  top: 0;\n  left: 0;\n  background-color: rgba(0, 0, 0, 0.5);\n  display: flex;\n  flex-direction: row;\n  justify-content: center;\n  align-items: center;\n  width: 100%;\n  height: 100%;\n}\n\n.videoContainer {\n  width: calc(100%);\n  margin: 0 auto;\n  box-sizing: border-box;\n  height: auto;\n  // aspect-ratio: 1.6;\n  // background-image: url('/imgs/videoUpload/video_cover.svg');\n  background-repeat: no-repeat;\n  background-size: cover;\n  display: flex;\n  flex-direction: row;\n  align-items: center;\n  justify-content: center;\n  position: relative;\n  height: 200px;\n}\n\n.musicBg {\n  background-color: #000;\n}\n\n.videoBg {\n  // background-image: url('/imgs/videoUpload/video_cover.svg');\n}\n\n.videoStyle {\n  height: 100% !important;\n  width: 100%;\n  background-color: #000;\n}\n\n.absoluteBoxLoadingContainer {\n  left: 0;\n  top: 0;\n  position: absolute;\n  width: 100%;\n  height: 100%;\n  display: flex;\n  flex-direction: column;\n  align-items: center;\n  justify-content: center;\n}\n\n.absoluteBoxLoading {\n  width: calc(100% - 36px);\n  height: auto;\n  aspect-ratio: 1.8;\n  background: #f4f4f4;\n  border-radius: 8px;\n  display: flex;\n  flex-direction: column;\n  align-items: center;\n  justify-content: flex-end;\n}\n\n.text {\n  font-style: normal;\n  font-weight: 500;\n  font-size: 12px;\n  line-height: 18px;\n  color: #000000;\n}\n\n.number {\n  margin: 6px 0px;\n  font-style: normal;\n  font-weight: 400;\n  font-size: 12px;\n  line-height: 18px;\n  /* identical to box height, or 150% */\n  color: #000000;\n}\n\n.inputBox {\n  width: 80%;\n  height: 7px;\n  border-radius: 8px;\n  margin: 0 8px;\n  background: #d9d9d9;\n  border-radius: 8px;\n  margin-bottom: 20px;\n}\n\n.progress {\n  height: 7px;\n  background: #ff6871;\n  border-radius: 8px;\n  transition: all 1s;\n}\n\n.uploadDone {\n  box-sizing: border-box;\n  display: flex;\n  width: 100%;\n  height: auto;\n  justify-content: space-between;\n  align-items: center;\n  margin: 4px 0;\n}\n\n.uploadDoneText {\n  font-style: normal;\n  font-weight: 400;\n  font-size: 10px;\n  line-height: 18px;\n\n  color: #d8000d;\n}\n\n.uploadDoneSize {\n  font-style: normal;\n  font-weight: 400;\n  font-size: 10px;\n  line-height: 18px;\n  /* identical to box height, or 180% */\n  color: #000000;\n}\n\n.coverTitle {\n  font-style: normal;\n  font-weight: 500;\n  font-size: 12px;\n  line-height: 18px;\n  /* identical to box height, or 150% */\n\n  color: #000000;\n  margin: 6px 0;\n}\n\n.coverDescription {\n  font-style: normal;\n  font-weight: 400;\n  font-size: 12px;\n  line-height: 18px;\n  /* or 150% */\n\n  text-align: right;\n\n  color: #484848;\n}\n\n.thumbnailContainer {\n  box-sizing: border-box;\n  width: 100%;\n  height: auto;\n  display: flex;\n  justify-content: flex-start;\n  align-items: flex-start;\n  flex-wrap: wrap;\n  margin: 8px 0;\n}\n\n.thumbnailContainer>div {\n  box-sizing: border-box;\n  width: 48%;\n  height: auto;\n  aspect-ratio: 1.7;\n  margin: 1%;\n  background: #f1f1f1;\n\n  position: relative;\n  display: flex;\n  justify-content: center;\n  align-items: center;\n}\n\n.thumbnailContainer>div>span {\n  font-style: normal;\n  font-weight: 500;\n  font-size: 12px;\n  line-height: 18px;\n  /* identical to box height, or 150% */\n\n  text-align: right;\n\n  color: #6b6b6b;\n}\n\n.buttonContainer {\n  box-sizing: border-box;\n  display: flex;\n  justify-content: space-between;\n  align-items: stretch;\n  // align-items: center;\n  width: 100%;\n  height: auto;\n  padding-bottom: 11px;\n  border-bottom: 1px solid #e9e9e9;\n}\n\n.buttonContainer .button {\n  font-style: normal;\n  font-weight: 400;\n  font-size: 14px;\n  line-height: 22px;\n  display: flex;\n  align-items: center;\n  text-align: center;\n  color: #d8000d;\n  border: 1px solid #d8000d;\n  background: inherit;\n  border-radius: 4px;\n  width: 49%;\n  height: auto;\n  // aspect-ratio: 4;\n  aspect-ratio: 8;\n  display: flex;\n  flex-direction: column;\n  justify-content: center;\n  align-items: center;\n  max-height: 38px;\n\n}\n\n.videoLink {\n  box-sizing: border-box;\n  width: 100%;\n  height: auto;\n  display: flex;\n  flex-direction: column;\n  justify-content: flex-start;\n  align-items: flex-start;\n}\n\n.videoLink .linkHeader {\n  box-sizing: border-box;\n  width: 100%;\n  height: auto;\n  display: flex;\n  flex-direction: row;\n  justify-content: space-between;\n  align-items: center;\n  margin: 5px 0;\n}\n\n.videoLink .linkHeader>p {\n  font-style: normal;\n  font-weight: 500;\n  font-size: 14px;\n  line-height: 22px;\n  color: #3c3c3c;\n}\n\n.videoLink .linkHeader>div {\n  width: auto;\n  display: flex;\n  justify-content: flex-end;\n}\n\n.videoLink .link {\n  box-sizing: border-box;\n  width: 100%;\n  height: auto;\n  display: flex;\n  flex-direction: row;\n  justify-content: flex-end;\n  align-items: center;\n  word-break: break-all;\n  text-align: left;\n  font-style: normal;\n  font-weight: 400;\n  font-size: 12px;\n  line-height: 19px;\n  color: #ff3c45;\n  margin: 5px 0;\n}\n\n.submitButtonsContainer {\n  box-sizing: border-box;\n  display: flex;\n  justify-content: space-between;\n  align-items: center;\n  width: 100%;\n  height: auto;\n  padding-bottom: 11px;\n  margin-top: 25px;\n}\n\n.submitButtonsContainer .button {\n  font-style: normal;\n  font-weight: 400;\n  font-size: 14px;\n  line-height: 22px;\n  display: flex;\n  align-items: center;\n  text-align: center;\n  color: #d8000d;\n  border: 1px solid #d8000d;\n  background: inherit;\n  border-radius: 4px;\n  width: 49%;\n  height: auto;\n  // aspect-ratio: 4;\n  aspect-ratio: 14;\n  max-height: 38px;\n  display: flex;\n  flex-direction: column;\n  justify-content: center;\n  align-items: center;\n  margin: 0 auto;\n}\n\n.submitButtonsContainer .button:nth-child(1) {\n  // background: #9D9D9D;\n  // border: 1px solid #9D9D9D;\n  background: #d8000d;\n  border: 1px solid #d8000d;\n  color: #ffffff;\n}\n\n.redBorder {\n  border: 1px solid #d8000d;\n}\n\n.grayBorder {\n  border: 1px solid #f1f1f1;\n  min-height: 100px;\n  // background: #eee;\n}\n\n.error {\n  font-style: normal;\n  font-weight: 500;\n  font-size: 14px;\n  line-height: 20px;\n  color: #ff9315;\n  margin-top: 8px;\n  margin-right: 20px;\n}\n\n.lds_ring {\n  display: inline-block;\n  position: relative;\n  width: 20px;\n  height: 20px;\n  margin-bottom: 10px;\n  // margin-right: 20px;\n}\n\n.lds_ring div {\n  box-sizing: border-box;\n  display: block;\n  position: absolute;\n  width: 14px;\n  height: 14px;\n  margin: 8px;\n  border: 1px solid #d8000d;\n  border-radius: 50%;\n  animation: lds_ring 1.2s cubic-bezier(0.5, 0, 0.5, 1) infinite;\n  border-color: #d8000d transparent transparent transparent;\n}\n\n.lds_ring div:nth-child(1) {\n  animation-delay: -0.45s;\n}\n\n.lds_ring div:nth-child(2) {\n  animation-delay: -0.3s;\n}\n\n.lds_ring div:nth-child(3) {\n  animation-delay: -0.15s;\n}\n\n@keyframes lds_ring {\n  0% {\n    transform: rotate(0deg);\n  }\n\n  100% {\n    transform: rotate(360deg);\n  }\n}\n\n@media only screen and (max-width: 1300px) {\n  .responsiveText {\n    flex-direction: column;\n  }\n}\n\n//------------------------loader style\n\n.lds_ringSave {\n  // display: inline-block;\n  // position: absolute;\n  // width: 100%;\n  height: 40px;\n  // top: 20px;\n  // left: 20px;\n  // margin-bottom: 10px;\n  // margin-right: 20px;\n}\n\n.lds_ringSave div {\n  box-sizing: border-box;\n  display: block;\n  position: absolute;\n  width: 14px;\n  height: 14px;\n  // margin: 8px;\n  border: 1px solid #d8000d;\n  border-radius: 50%;\n  animation: lds_ring 1.2s cubic-bezier(0.5, 0, 0.5, 1) infinite;\n  border-color: #d8000d transparent transparent transparent;\n}\n\n.lds_ringSave div:nth-child(1) {\n  animation-delay: -0.45s;\n}\n\n.lds_ringSave div:nth-child(2) {\n  animation-delay: -0.3s;\n}\n\n.lds_ringSave div:nth-child(3) {\n  animation-delay: -0.15s;\n}\n\n@keyframes lds_ringSave {\n  0% {\n    transform: rotate(0deg);\n  }\n\n  100% {\n    transform: rotate(360deg);\n  }\n}\n\n//------------------------loader style\n\n.lds_ringSubmit {\n  // display: inline-block;\n  // position: absolute;\n  // width: 100%;\n  height: 30px !important;\n  width: 30px !important;\n  // top: 20px;\n  // left: 20px;\n  // margin-bottom: 10px;\n  // margin-right: 20px;\n}\n\n.noBackground {\n  background-color: transparent !important;\n}\n\n.lds_ringSubmit div {\n  box-sizing: border-box;\n  display: block;\n  position: absolute;\n  width: 14px;\n  height: 14px;\n  // margin: 8px;\n  border: 1px solid #ffffff;\n  border-radius: 50%;\n  animation: lds_ring 1.2s cubic-bezier(0.5, 0, 0.5, 1) infinite;\n  border-color: #ffffff transparent transparent transparent;\n}\n\n.lds_ringSubmit div:nth-child(1) {\n  animation-delay: -0.45s;\n}\n\n.lds_ringSubmit div:nth-child(2) {\n  animation-delay: -0.3s;\n}\n\n.lds_ringSubmit div:nth-child(3) {\n  animation-delay: -0.15s;\n}\n\n@keyframes lds_ringSubmit {\n  0% {\n    transform: rotate(0deg);\n  }\n\n  100% {\n    transform: rotate(360deg);\n  }\n}\n\n\n@media only screen and (max-width: 1000px) {\n\n  .container {\n    width: calc(90%);\n    // margin: 0 10px;\n    flex-direction: column;\n    justify-content: flex-start;\n    align-items: center;\n    margin: 0 auto;\n  }\n\n  .flexStyle {\n    flex-direction: column;\n    justify-content: flex-start;\n    align-items: center;\n  }\n\n  .activeMenu,\n  .unActiveMenu {\n    width: 40%;\n  }\n}\n\n@media only screen and (max-width: 300px) {\n\n  .container {\n    width: calc(70%);\n  }\n\n}"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"container": `styles_container__MXuYV`,
	"information": `styles_information__v-CfO`,
	"switchDescription": `styles_switchDescription__fSenK`,
	"sidebar": `styles_sidebar__ptUSl`,
	"audioBox": `styles_audioBox__tAoR2`,
	"activeMenu": `styles_activeMenu__3OuRR`,
	"unActiveMenu": `styles_unActiveMenu__ukahj`,
	"experimental": `styles_experimental__CMxAP`,
	"imageAbsoluteCover": `styles_imageAbsoluteCover__Z0zvq`,
	"videoContainer": `styles_videoContainer__4IR0R`,
	"musicBg": `styles_musicBg__tM7JM`,
	"videoStyle": `styles_videoStyle__eL7+s`,
	"absoluteBoxLoadingContainer": `styles_absoluteBoxLoadingContainer__++yEi`,
	"absoluteBoxLoading": `styles_absoluteBoxLoading__7t6Ks`,
	"text": `styles_text__dThwI`,
	"number": `styles_number__lf7Em`,
	"inputBox": `styles_inputBox__V620u`,
	"progress": `styles_progress__c6hkw`,
	"uploadDone": `styles_uploadDone__XC64X`,
	"uploadDoneText": `styles_uploadDoneText__WnMLQ`,
	"uploadDoneSize": `styles_uploadDoneSize__NC2VW`,
	"coverTitle": `styles_coverTitle__9ZBSQ`,
	"coverDescription": `styles_coverDescription__b7ZyE`,
	"thumbnailContainer": `styles_thumbnailContainer__9NqVY`,
	"buttonContainer": `styles_buttonContainer__U5Tck`,
	"button": `styles_button__USepc`,
	"videoLink": `styles_videoLink__2zO1V`,
	"linkHeader": `styles_linkHeader__rWaXy`,
	"link": `styles_link__5ydTE`,
	"submitButtonsContainer": `styles_submitButtonsContainer__AUX5P`,
	"redBorder": `styles_redBorder__YGqHJ`,
	"grayBorder": `styles_grayBorder__Obrv5`,
	"error": `styles_error__xX3Ai`,
	"lds_ring": `styles_lds_ring__lDIHb`,
	"responsiveText": `styles_responsiveText__pJ24t`,
	"lds_ringSave": `styles_lds_ringSave__ZnH0g`,
	"lds_ringSubmit": `styles_lds_ringSubmit__oShXu`,
	"noBackground": `styles_noBackground__if6nc`,
	"flexStyle": `styles_flexStyle__XV5tp`
};
export default ___CSS_LOADER_EXPORT___;
